import React from "react";
import { makeStyles } from "tss-react/mui";
import Header from "./header";
import { Box } from "@mui/material";
import { AppSize, IFaqDataType, pxToRem } from "@/util";
import FaqCard from "./faqCard";

interface FaqProps {
  faqData: IFaqDataType[];
}

export default function Faq({ faqData }: FaqProps) {
  const { classes } = styles();
  const [localFaqData, setLocalFaqData] = React.useState(faqData);

  const handleToggle = (index: number) => {
    setLocalFaqData((prev) =>
      prev.map((item, key) => ({
        ...item,
        active: key === index ? !item.active : false,
      }))
    );
  };
  return (
    <Box className={classes.container}>
      <Header
        name={"Frequently Asked Questions"}
        isAction={false}
        description={
          "Find answers to common questions about buying, investing, and working with Arel Homes"
        }
      />
      <Box className={`${classes.sub}`}>
        {localFaqData.map((value, key) => (
          <FaqCard toggle={() => handleToggle(key)} value={value} key={key} />
        ))}
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    padding: pxToRem(AppSize.padding),
    // minHeight: pxToRem(600),
    // padding: `0px ${pxToRem(AppSize.padding)}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(30)} 0px`,
    },
  },
  sub: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(2),
    },
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(3),
    justifyContent: "space-between",
  },

  debug: {
    border: "1px solid green",
  },
}));
